/* Add to cart - the reference's cart drawer.
 *
 * Verified by driving a real browser against yatasbedding.com.tr and clicking
 * "Sepete Ekle": a panel slides in from the right on desktop (full height,
 * ~590px) and up from the bottom as a sheet on mobile. It lists the cart lines
 * with a thumbnail, variant line, delete button and a live quantity stepper,
 * then a running total beside a solid "go to cart" pill, with "keep shopping"
 * as a quiet text link underneath.
 *
 * Delegated from document so it survives re-renders of the product section.
 */
(function () {
  'use strict';

  document.documentElement.setAttribute('data-ybn-atc', 'drawer');

  var FORM = 'form.ybn-buybox__form, #ybn-product-form';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // cart.js returns minor units; the reference shows "999,90 TL", we show euros.
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: currency || 'EUR',
      }).format((cents || 0) / 100);
    } catch (e) {
      return '€ ' + ((cents || 0) / 100).toFixed(2).replace('.', ',');
    }
  }

  function thumb(url) {
    if (!url) return '';
    return url.indexOf('?') === -1 ? url + '?width=160' : url + '&width=160';
  }

  /* ----------------------------------------------------------------- drawer */

  function root() {
    return document.querySelector('.ybn-cd');
  }

  function close() {
    var el = root();
    if (!el) return;
    el.classList.remove('is-open');
    document.body.classList.remove('ybn-cd-open');
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 260);
  }

  function ensure() {
    var el = root();
    if (el) return el;
    el = document.createElement('div');
    el.className = 'ybn-cd';
    el.innerHTML =
      '<div class="ybn-cd__scrim" data-cd-close></div>' +
      '<aside class="ybn-cd__panel" role="dialog" aria-modal="true" aria-label="Winkelwagen">' +
      '<header class="ybn-cd__head">' +
      '<h2 class="ybn-cd__title">Product toegevoegd aan uw winkelwagen</h2>' +
      '<button class="ybn-cd__close" type="button" aria-label="Sluiten" data-cd-close>&times;</button>' +
      '</header>' +
      '<div class="ybn-cd__body" data-cd-body></div>' +
      '<footer class="ybn-cd__foot" data-cd-foot></footer>' +
      '</aside>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { close(); return; }

      var dec = e.target.closest('[data-cd-dec]');
      var inc = e.target.closest('[data-cd-inc]');
      var del = e.target.closest('[data-cd-del]');
      var row = e.target.closest('[data-cd-line]');
      if (!row) return;

      var line = parseInt(row.getAttribute('data-cd-line'), 10);
      var qty = parseInt(row.getAttribute('data-cd-qty'), 10) || 1;

      if (del) change(line, 0);
      else if (dec) change(line, Math.max(0, qty - 1));
      else if (inc) change(line, qty + 1);
    });

    return el;
  }

  function render(cart) {
    var el = ensure();
    var body = el.querySelector('[data-cd-body]');
    var foot = el.querySelector('[data-cd-foot]');

    if (!cart || !cart.items || !cart.items.length) {
      body.innerHTML = '<p class="ybn-cd__empty">Uw winkelwagen is leeg.</p>';
      foot.innerHTML = '';
      return;
    }

    var html = '';
    cart.items.forEach(function (it, i) {
      var variant =
        it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      html +=
        '<div class="ybn-cd__line" data-cd-line="' + (i + 1) + '" data-cd-qty="' + it.quantity + '">' +
        '<a class="ybn-cd__thumb" href="' + esc(it.url) + '">' +
        (it.image ? '<img src="' + esc(thumb(it.image)) + '" alt="" width="80" height="80">' : '') +
        '</a>' +
        '<div class="ybn-cd__info">' +
        '<div class="ybn-cd__row">' +
        '<a class="ybn-cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<button class="ybn-cd__del" type="button" aria-label="Verwijderen" data-cd-del>' +
        '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
        '<path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" fill="none" stroke="currentColor" ' +
        'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '</div>' +
        (variant ? '<p class="ybn-cd__variant">' + esc(variant) + '</p>' : '') +
        '<div class="ybn-cd__row ybn-cd__row--bottom">' +
        '<div class="ybn-cd__qty">' +
        '<button type="button" aria-label="Minder" data-cd-dec>&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" aria-label="Meer" data-cd-inc>+</button>' +
        '</div>' +
        '<span class="ybn-cd__price">' + money(it.line_price, cart.currency) + '</span>' +
        '</div>' +
        '</div></div>';
    });
    body.innerHTML = html;

    foot.innerHTML =
      '<div class="ybn-cd__totals">' +
      '<div class="ybn-cd__total">' +
      '<span class="ybn-cd__total-label">Totaal</span>' +
      '<span class="ybn-cd__total-value">' + money(cart.total_price, cart.currency) + '</span>' +
      '</div>' +
      '<a class="ybn-cd__go" href="/cart">Naar winkelwagen</a>' +
      '</div>' +
      '<button class="ybn-cd__continue" type="button" data-cd-close>Verder winkelen</button>';
  }

  function open(cart) {
    render(cart);
    var el = root();
    document.body.classList.add('ybn-cd-open');

    // The panel is appended while the page is mid-scroll, so its body can
    // inherit a scroll offset and hide the header. Pin it back to the top.
    var body = el.querySelector('[data-cd-body]');
    if (body) body.scrollTop = 0;
    el.querySelector('.ybn-cd__panel').scrollTop = 0;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    });
  }

  /* ------------------------------------------------------------------- data */

  function counts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      if (cart.item_count > 0) n.removeAttribute('hidden');
      else n.setAttribute('hidden', '');
    });
  }

  function change(line, quantity) {
    var el = root();
    if (el) el.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (el) el.classList.remove('is-busy');
        if (!cart) return;
        counts(cart);
        render(cart);
      })
      .catch(function () { if (el) el.classList.remove('is-busy'); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORM)) return;
    e.preventDefault();

    var btn = form.querySelector('[data-atc]');
    if (btn && btn.disabled) return;
    var restore = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.textContent = restore; }
        if (!res.ok) {
          alert((res.data && res.data.description) || 'Toevoegen niet gelukt.');
          return;
        }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { counts(cart); open(cart); });
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.textContent = restore; }
      });
  });
})();
